/*
 * Copyright (C) GMS Inc - All Rights Reserved
 * This file is part of GMSCloud. - Proprietary and confidential
 * Unauthorized copying of this file, via any medium is strictly prohibited
 *
 * Created on   : 18-Jul-2026
 * @author      : Vincy R
 * Requirement# : 22300
 * Purpose      : Status pill — green "Published" / amber "Draft".
 */

import React from 'react';
import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import { TemplateStatus, relativeWhen } from './libraryModel';

/** Clean status pill: green dot + "Published", amber dot + "Draft". */
export default function StatusChip({ status }: { status: TemplateStatus }) {
  const draft = status === 'draft';
  const fg = draft ? 'warning.main' : 'success.main';
  return (
    <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.6, fontSize: 11, fontWeight: 600,
      px: 1.1, py: 0.25, borderRadius: 999, color: fg, whiteSpace: 'nowrap', flexShrink: 0,
      bgcolor: theme => alpha(draft ? theme.palette.warning.main : theme.palette.success.main, 0.16) }}>
      <Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: fg }} />
      {draft ? 'Draft' : 'Published'}
    </Box>
  );
}

/** Small amber "Draft" badge flagging an unpublished saved draft alongside a published version —
 *  used by both the By-tenant cards and the Provider grid card (same scope-draft concept). */
export function HasDraftBadge({ when }: { when?: string | null }) {
  const w = relativeWhen(when ?? '');
  return (
    <Box component="span" title={w ? `Draft saved ${w}` : 'Unpublished saved draft'}
      sx={{ fontSize: 11, fontWeight: 700, color: 'warning.dark', whiteSpace: 'nowrap',
        bgcolor: (theme) => alpha(theme.palette.warning.main, 0.18), px: 1, py: 0.25, borderRadius: 999 }}>
      Draft
    </Box>
  );
}
